pageId = "page-team-dingtalk_binding_members"
page = "#" + pageId

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  tower.adjustSubGroupsTag $('.member-list')

